module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter TableOfContents"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_xxi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxi"
    }
  }), _c('div', {
    staticClass: "title-block"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxi"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_xxi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847675705_tableofcontents"
    }
  }, [_c('i', [_vm._v("Contents")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block list-toc"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847675705_chapter_01#rw-title-block_108471-00001"
    }
  }, [_vm._v("1 A Boyhood in Scotland")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847675705_chapter_02#rw-title-block_108472-00001"
    }
  }, [_vm._v("2 A New World")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847675705_chapter_03#rw-title-block_108473-00001"
    }
  }, [_vm._v("3 Life on a Wisconsin Farm")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675705_chapter_04#rw-title-block_108474-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 A Paradise of Birds")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675705_chapter_05#rw-title-block_108475-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Young Hunters")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675705_chapter_06#rw-title-block_108476-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Ploughboy")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675705_chapter_07#rw-title-block_108477-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Knowledge and Inventions")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847675705_chapter_08#rw-title-block_108478-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The World and the University")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28d89767","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675705_tableofcontents_02.vue
// module id = 72
// module chunks = 0